'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}else{return Array.from(arr)}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const ex=require('pulsar-utils/dist-es6/ex');
const LatLongLocation=require('pulsar-fatigue/dist-es6/domain/latLongLocation');
const GeocodedStatus=require('pulsar-driveplan/dist-es6/domain/geocodedStatus');
const GeocodedStatusTimeSeriesPoint=require('pulsar-driveplan/dist-es6/domain/geocodedStatusTimeSeriesPoint');
const HosStatusDurations=require('../../../dist-es6/client/dtos/hosStatusDurations');
const fdie=require('../../../dist-es6/client/extensions/fatigueDistributionIterableExtensions');
const DistributionParameters=require('../../../dist-es6/server/services/distributionParameters');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const EntityDictionary=require('pulsar-utils/dist-es6/domain/entityDictionary');
const StatisticsAggregator=require('../../../dist-es6/server/services/statisticsAggregator');
const treeUtils=require('pulsar-utils/dist-es6/treeUtils');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const PersonStatisticsViewModel=require('../../../dist-es6/client/viewModels/personStatisticsViewModel');
const DashboardPersonViewModel=require('../../../dist-es6/client/viewModels/dashboardPersonViewModel');
const ForecastPersonViewModel=require('../../../dist-es6/client/viewModels/forecastPersonViewModel');
const FleetIncidentsPersonViewModel=require('../../../dist-es6/client/viewModels/fleetIncidentsPersonViewModel');
const FatigueTrendsPersonViewModel=require('../../../dist-es6/client/viewModels/fatigueTrendsPersonViewModel');
const GroupStatisticsViewModel=require('../../../dist-es6/client/viewModels/groupStatisticsViewModel');
const IncidentViewModel=require('../../../dist-es6/client/viewModels/incidentViewModel');
const DutyViewModel=require('../../../dist-es6/client/viewModels/dutyViewModel');
const TripViewModel=require('../../../dist-es6/client/viewModels/tripViewModel');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const CalendarRange=require('pulsar-utils/dist-es6/time/calendarRange');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');

const GroupDataSocketOptions={
timeoutInSeconds:300,
retryOptions:{
retries:5,
maxTimeout:30000},

throwOnUnexpectedError:!0};


const DefaultGroupViewModelBuilder=function(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key]}return new(Function.prototype.bind.apply(GroupStatisticsViewModel,[null].concat(args)))};let

StatisticalDisplayDataService=function(_BaseService){_inherits(StatisticalDisplayDataService,_BaseService);_createClass(StatisticalDisplayDataService,null,[{key:'$inject',get:function()
{
return['$state','socketService','groupsPopulationService','timeZoneService','organizationDefaultsService','dateService'];
}}]);

function StatisticalDisplayDataService($state,socketService,groupsPopulationService,timeZoneService,organizationDefaultsService,dateService){_classCallCheck(this,StatisticalDisplayDataService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));

_this._$state=$state;
_this._socketService=socketService;
_this._groupsPopulationService=groupsPopulationService;
_this._timeZoneService=timeZoneService;
_this._organizationDefaultsService=organizationDefaultsService;
_this._dateService=dateService;return _this;
}StatisticalDisplayDataService.prototype.

fetchDashboardData=function(){var ref=_asyncToGenerator(function*(){
const socketCommandName='GetDashboardDisplayData';

const rawDataInflator=function(rawDisplayData){
for(let person of rawDisplayData.persons){
person.lastKnownStatus.time=SocketResponse.safeDeserializeDate(person.lastKnownStatus.time);
person.estimatesAsOfTime=rawDisplayData.estimatesAsOfTime;
}
return rawDisplayData;
};

const groupViewModelBuilder=function(){for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2]}

const gsvm=new(Function.prototype.bind.apply(GroupStatisticsViewModel,[null].concat(args)));
gsvm.maxFatigueForHeader=gsvm.maxLastKnownFatigue;
return gsvm;
};

const viewScheduleBuilder=this._getViewScheduleBuilderForCurrentTime('lastKnownStatus.time');
const rootPersonViewModelBuilder=function(personStats){return new DashboardPersonViewModel(personStats,viewScheduleBuilder(personStats))};
const treePersonViewModelBuilder=function(rootPersonViewModel){return new DashboardPersonViewModel(rootPersonViewModel.statistics,rootPersonViewModel.viewSchedule)};

return yield this._fetchLatestGroupData(socketCommandName,void 0,rawDataInflator,groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder);
});function fetchDashboardData(){return ref.apply(this,arguments)}return fetchDashboardData}();StatisticalDisplayDataService.prototype.

fetchForecastData=function(){var ref=_asyncToGenerator(function*(){let options=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};
const socketCommandName='GetForecastDisplayData';

let currentTimeForForecast;
const rawDataInflator=function(rawDisplayData){

currentTimeForForecast=SocketResponse.safeDeserializeDate(rawDisplayData.currentTimeForForecast);

for(let person of rawDisplayData.persons){
if(_.exists(person.forecast)){

person.forecast.schedule.duties=person.forecast.schedule.duties.map(function(d){return new DutyViewModel(d)});
person.forecast.schedule.trips=person.forecast.schedule.trips.map(function(t){return new TripViewModel(t)});
if(person.forecast.schedule.bounds){
person.forecast.schedule.bounds=new TimeInterval(person.forecast.schedule.bounds);
}
if(person.forecast.schedule.sleepPromotingIntervals&&person.forecast.schedule.sleepPromotingIntervals.length){
person.forecast.schedule.sleepPromotingIntervals=person.forecast.schedule.sleepPromotingIntervals.map(function(s){return new TimeInterval(s)});
}

person.forecast.scenario.duties=person.forecast.scenario.duties.map(function(d){return new DutyViewModel(d)});
person.forecast.scenario.trips=person.forecast.scenario.trips.map(function(t){return new TripViewModel(t)});
person.forecast.scenario.sleep=person.forecast.scenario.sleep.map(function(s){return new TimeInterval(s)});
if(person.forecast.scenario.bounds){
person.forecast.scenario.bounds=new TimeInterval(person.forecast.scenario.bounds);
}
person.forecast.scenario.fatigue.forEach(function(tsp){return tsp.time=new Date(tsp.time)});

person.forecast.currentShiftHosStatusDurations=HosStatusDurations.fromJSON(person.forecast.currentShiftHosStatusDurations);

person.forecast.predictedWorkday=new TimeInterval(person.forecast.predictedWorkday);

if(person.forecast.currentHosStatus){
const time=_.isDate(person.forecast.currentHosStatus.time)?person.forecast.currentHosStatus.time:new Date(person.forecast.currentHosStatus.time);
const status=GeocodedStatus.Statuses[person.forecast.currentHosStatus.value.status.name];
const{lat:lat,long:long,description:description}=person.forecast.currentHosStatus.value.location;
const location=_.attempt(function(){return new LatLongLocation(lat,long,description)});

person.forecast.currentHosStatus=GeocodedStatusTimeSeriesPoint.create(time,status,!_.isError(location)?location:null);
}
}

if(_.exists(person,'effectiveStatus.time')&&!_.isDate(person.effectiveStatus.time)){
person.effectiveStatus.time=new Date(person.effectiveStatus.time);
}

if(_.exists(person,'lastKnownStatus.time')&&!_.isDate(person.lastKnownStatus.time)){
person.lastKnownStatus.time=new Date(person.lastKnownStatus.time);
}

person.currentTime=currentTimeForForecast;
person.estimatesAsOfTime=rawDisplayData.estimatesAsOfTime;
}
return rawDisplayData;
};

const groupViewModelBuilder=DefaultGroupViewModelBuilder;
const viewScheduleBuilder=this._getViewScheduleBuilderForCurrentTime('currentStatus.time');
const rootPersonViewModelBuilder=function(personStats){return new ForecastPersonViewModel(personStats,viewScheduleBuilder(personStats))};
const treePersonViewModelBuilder=function(rootPersonViewModel){return new ForecastPersonViewModel(rootPersonViewModel.statistics,rootPersonViewModel.viewSchedule)};

const results=yield this._fetchLatestGroupData(socketCommandName,options,rawDataInflator,groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder);

results.currentTimeForForecast=currentTimeForForecast;

return results;
});function fetchForecastData(){let options=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};return ref.apply(this,arguments)}return fetchForecastData}();StatisticalDisplayDataService.prototype.

_getViewScheduleBuilderForCurrentTime=function _getViewScheduleBuilderForCurrentTime(propertyPath){var _this2=this;
const now=this._dateService.now();

const _getTime=_.exists(propertyPath)?
function(personData){return _.get(personData,propertyPath,now)}:
function(personData){return now};

const viewScheduleBuilder=function(personData){return _this2._getViewScheduleFunc({
id:personData.id,
employeeId:personData.employeeId,
interval:TimeInterval.fromPoint(_getTime(personData)||now),
timezone:personData.timezone})};


return viewScheduleBuilder;
};StatisticalDisplayDataService.prototype.

_fetchLatestGroupData=function(){var ref=_asyncToGenerator(function*(socketCommandName,socketRequestBody,rawDataInflator,groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder){
let{body:rawDisplayData}=yield this._socketService.sendAndWaitForResponse(socketCommandName,socketRequestBody,GroupDataSocketOptions);

return yield this._buildViewModels(groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder,rawDisplayData,rawDataInflator);
});function _fetchLatestGroupData(socketCommandName,socketRequestBody,rawDataInflator,groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder){return ref.apply(this,arguments)}return _fetchLatestGroupData}();StatisticalDisplayDataService.prototype.

_getFleetInsightPersonViewScheduleBuilderFor=function _getFleetInsightPersonViewScheduleBuilderFor(calendarRange){var _this3=this;
_.ensureInstanceOf(CalendarRange,calendarRange);

return function(personStats){return _this3._getViewScheduleFunc({
id:personStats.id,
employeeId:personStats.employeeId,
interval:calendarRange.asExpandedTimeInterval(personStats.timezone).expandToRoundTarget('week',personStats.timezone),
timezone:personStats.timezone})};

};StatisticalDisplayDataService.prototype.

fetchFleetIncidentsDataFor=function(){var ref=_asyncToGenerator(function*(_ref){var _this4=this;let{queryInterval:queryInterval}=_ref;

const{body:rawDisplayData}=yield this._socketService.sendAndWaitForResponse('GetFleetIncidentsDisplayData',{queryInterval:queryInterval},{throwOnUnexpectedError:!0});

const incidentTypesByCode=_.keyBy(rawDisplayData.incidentTypes,'code');


const viewScheduleBuilder=function(personStats){return function(){return void 0}};

const groupViewModelBuilder=DefaultGroupViewModelBuilder;

const rootPersonViewModelBuilder=function(personStats){
const incidents=_this4._createIncidentViewModelsFor(personStats,incidentTypesByCode);
return new FleetIncidentsPersonViewModel(personStats,viewScheduleBuilder(personStats),incidents);
};

const treePersonViewModelBuilder=function(rootViewModel){return new FleetIncidentsPersonViewModel(rootViewModel.statistics,rootViewModel.viewSchedule,rootViewModel.incidents)};

const results=yield this._buildViewModels(groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder,rawDisplayData);
results.incidentTypes=rawDisplayData.incidentTypes;

return results;
});function fetchFleetIncidentsDataFor(_ref2){let{queryInterval:queryInterval}=_ref2;return ref.apply(this,arguments)}return fetchFleetIncidentsDataFor}();StatisticalDisplayDataService.prototype.

fetchFatigueTrendsDataFor=function(){var ref=_asyncToGenerator(function*(params){
let{calendarRange:calendarRange,requestedOrgStats:requestedOrgStats,requestedGroupStats:requestedGroupStats,requestedPersonalStats:requestedPersonalStats}=params;
_.ensureInstanceOf(Array,requestedOrgStats);
_.ensureInstanceOf(Array,requestedGroupStats);
_.ensureInstanceOf(Array,requestedPersonalStats);

const{body:rawDisplayData}=yield this._socketService.sendAndWaitForResponse(
'GetFleetInsightDisplayData',{
calendarRange:calendarRange,
requestedOrgStats:requestedOrgStats,
requestedGroupStats:requestedGroupStats,
requestedPersonalStats:requestedPersonalStats},
{
throwOnUnexpectedError:!0});


const viewScheduleBuilder=this._getFleetInsightPersonViewScheduleBuilderFor(calendarRange);

const groupViewModelBuilder=function(){for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3]}

const gsvm=new(Function.prototype.bind.apply(GroupStatisticsViewModel,[null].concat(args)));
gsvm.maxFatigueForHeader=gsvm.maxFatigueOnDuty;
gsvm.fatigueDistribution=fdie(gsvm.aggregatePersons.map(function(p){return p.statistics.fatigueDistribution})).aggregate(DistributionParameters.DefaultFatigueDistributionParameters);
return gsvm;
};

const rootPersonViewModelBuilder=function(personStats){
const personViewModel=new FatigueTrendsPersonViewModel(personStats,viewScheduleBuilder(personStats));
_updateFatigueDistributionMetaData(personViewModel.statistics.fatigueDistribution,personViewModel);
return personViewModel;
};

const treePersonViewModelBuilder=function(rootViewModel){
return new FatigueTrendsPersonViewModel(rootViewModel.statistics,rootViewModel.viewSchedule);
};

return yield this._buildViewModels(groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder,rawDisplayData);
});function fetchFatigueTrendsDataFor(params){return ref.apply(this,arguments)}return fetchFatigueTrendsDataFor}();StatisticalDisplayDataService.prototype.

_buildViewModels=function(){var ref=_asyncToGenerator(function*(groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder,rawDisplayData,rawDataInflator){
_.ensureInstanceOf('function',rootPersonViewModelBuilder);
_.ensureInstanceOf('function',treePersonViewModelBuilder);
_.ensureInstanceOf('object',rawDisplayData);

const organizationThresholds=yield this._organizationDefaultsService.getOrganizationThresholds();

if(_.exists(rawDataInflator)){
rawDisplayData.estimatesAsOfTime=SocketResponse.safeDeserializeDate(rawDisplayData.estimatesAsOfTime);
rawDisplayData=rawDataInflator(rawDisplayData);
}

const aggregatePersonViewModelsForOrg=rawDisplayData.persons.map(function(personStats){return rootPersonViewModelBuilder(personStats)});

const groupsViewModels=_constructViewModelTree(
groupViewModelBuilder,
treePersonViewModelBuilder,
rawDisplayData.groups,
EntityDictionary.create(aggregatePersonViewModelsForOrg),
organizationThresholds);

const personsAssignedToAGroup=_(groupsViewModels).map('aggregatePersons').flatten().keyBy(function(p){return p.id}).value();
const personsNotAssignedToAnyGroup=aggregatePersonViewModelsForOrg.filter(function(person){return!_.exists(personsAssignedToAGroup[person.id])});

const aggregateOrgStats=rawDisplayData.aggregateOrgStats||{};

const specialOrganizationGroupViewModel=groupViewModelBuilder(
null,
'Organization',
aggregatePersonViewModelsForOrg,
personsNotAssignedToAnyGroup,
aggregateOrgStats.numTripsOnDuty,
aggregateOrgStats.numPersonsOnDuty,
aggregateOrgStats.maxFatigueOnDuty,
aggregateOrgStats.maxLastKnownFatigue,
aggregateOrgStats.averageHoursOfSleepPerDay,
aggregateOrgStats.averageFatigueOnDuty,
organizationThresholds.fatigueThreshold,
organizationThresholds.deviationThreshold,void 0,!0);



_bringUpGroupMembershipsFromChilden(specialOrganizationGroupViewModel,groupsViewModels);
for(const notAssignedPerson of personsNotAssignedToAnyGroup){
notAssignedPerson.groupMembershipsAtScope.push(specialOrganizationGroupViewModel);
}

return{
groupTree:[specialOrganizationGroupViewModel].concat(groupsViewModels),
estimatesAsOfTime:rawDisplayData.estimatesAsOfTime};

});function _buildViewModels(groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder,rawDisplayData,rawDataInflator){return ref.apply(this,arguments)}return _buildViewModels}();StatisticalDisplayDataService.prototype.

_getViewScheduleFunc=function _getViewScheduleFunc(_ref3){var _this5=this;let{id:id,employeeId:employeeId,interval:interval,timezone:timezone}=_ref3;
_.ensureInstanceOf('string',id);
_.ensureInstanceOf('string',employeeId);
_.ensureInstanceOf(TimeInterval,interval);
_.ensureInstanceOf('string',timezone);
return function(){let{asString=!1,uiSref=!1}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};return!asString&&!uiSref?
_this5._$state.go('fdc.features.personalSchedule',{id:id,interval:interval,timezone:timezone,employeeId:employeeId}):
uiSref?
`fdc.features.personalSchedule({ id: "${id}", interval: "${interval.start.toISOString()}-to-${interval.end.toISOString()}", timezone: "${timezone}", employeeId: "${employeeId}" })`:
`/#/personalSchedule?id=${id}`+
`&employeeId=${encodeURIComponent(employeeId)}`+
`&interval=${encodeURIComponent(`${interval.start.toISOString()}-to-${interval.end.toISOString()}`)}`+
`&timezone=${encodeURIComponent(timezone)}`};
};StatisticalDisplayDataService.prototype.

_createIncidentViewModelsFor=function _createIncidentViewModelsFor(personStats,incidentTypesByCode){
if(personStats.incidents.length===0){
return[];
}

const timezone=personStats.timezone;
const numIncidents=personStats.incidents.length;
const incidentViewModels=Array(numIncidents);

for(let i=0;i<numIncidents;i++){
const rawIncident=personStats.incidents[i];
const viewScheduleFunc=this._getViewScheduleFunc({
id:personStats.id,
employeeId:personStats.employeeId,
interval:TimeInterval.fromPoint(rawIncident.time),
timezone:timezone});


incidentViewModels[i]=IncidentViewModel.createFrom(
rawIncident,
incidentTypesByCode[rawIncident.code],
timezone,
viewScheduleFunc);
}

return incidentViewModels;
};return StatisticalDisplayDataService}(BaseService);


function _constructViewModelTree(groupViewModelBuilder,treePersonViewModelBuilder,rawGroupTree,orgPersonViewModelsById,defaultThresholds){
const viewModelTree=treeUtils.map(rawGroupTree,function(group){
const effectiveGroupFatigueThreshold=ex(group.fatigueThreshold).otherwise(defaultThresholds.fatigueThreshold);
const effectiveGroupDeviationThreshold=ex(group.deviationThreshold).otherwise(defaultThresholds.deviationThreshold);

const directPersonViewModels=_constructPersonViewModelsForTree(treePersonViewModelBuilder,group.directlyAssignedPersonIds,orgPersonViewModelsById);
const directPersonViewModelsById=_.keyBy(directPersonViewModels,'id');

const aggregatePersonViewModels=_constructPersonViewModelsForTree(treePersonViewModelBuilder,group.aggregatedPersonIds,orgPersonViewModelsById,directPersonViewModelsById);

const groupViewModel=groupViewModelBuilder(

group.id,
group.name,
aggregatePersonViewModels,
directPersonViewModels,
group.numTripsOnDuty,
group.numPersonsOnDuty,
group.maxFatigueOnDuty,
group.maxLastKnownFatigue,
group.averageHoursOfSleepPerDay,
group.averageFatigueOnDuty,
effectiveGroupFatigueThreshold,
effectiveGroupDeviationThreshold);


for(const directPersonViewModel of directPersonViewModels){
directPersonViewModel.groupMembershipsAtScope.push(groupViewModel);
}

return groupViewModel;
});


const reverseTraversableTree=[].concat(_toConsumableArray(treeUtils.flatten(viewModelTree))).reverse();
for(const groupViewModel of reverseTraversableTree){
_bringUpGroupMembershipsFromChilden(groupViewModel,groupViewModel.children);
}
return viewModelTree;
}

function _bringUpGroupMembershipsFromChilden(groupViewModel,children){
const unprocessedAggregatesById=_.keyBy(groupViewModel.aggregatePersons,function(p){return p.id});
for(const child of children){
for(const aggregatePerson of child.aggregatePersons){
_.pushMany(unprocessedAggregatesById[aggregatePerson.id].groupMembershipsAtScope,aggregatePerson.groupMembershipsAtScope);
}
}
}

function _constructPersonViewModelsForTree(treePersonViewModelBuilder,personIds,orgPersonViewModelsById){let directPersonViewModelsById=arguments.length>3&&arguments[3]!==void 0?arguments[3]:null;
return personIds.map(function(personId){return orgPersonViewModelsById[personId]}).
filter(function(orgPersonViewModel){return _.exists(orgPersonViewModel)}).
map(function(orgPersonViewModel){
const directPersonViewModel=_.exists(directPersonViewModelsById)?directPersonViewModelsById[orgPersonViewModel.id]:null;
return ex(directPersonViewModel).otherwise(treePersonViewModelBuilder(orgPersonViewModel));
});
}






function _updateFatigueDistributionMetaData(fatigueDistribution,personViewModel){
for(const bin of fatigueDistribution.bins){
for(const item of bin){
item.metaData.person=personViewModel;
}
}
}

module.exports=StatisticalDisplayDataService;
//# sourceMappingURL=statisticalDisplayDataService.js.map
